import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <a href="https://github.com/F-Benjamin">Homemade by Benjamin</a>
    </div>
  );
};

export default Footer;
